module.exports = __webpack_public_path__ + "img/1f_r_tonya@2x.687113d3.png";